import { ClienteBatteria } from "./ClienteBatteria";
import { ClienteSlotDialog } from "./ClienteSlotDialog";

// Un solo controllo per i tre dettagli (Batteria, Casa, Rete): aperti sia dalle bolle sull'immagine sia dalle card sotto
export function SlotDialogs({ slot, onClose, src, soh, temp }) {
  if (!src) return null;
  return (
    <>
      <ClienteBatteria open={slot === "batteria"} onClose={onClose} src={src} soh={soh} temp={temp} />
      <ClienteSlotDialog open={slot === "casa"} kind="casa" onClose={onClose} src={src} />
      <ClienteSlotDialog open={slot === "rete"} kind="rete" onClose={onClose} src={src} />
    </>
  );
}
